<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  <path d="M0 0h24v24H0z" fill="none" />
  <g fill="none">
    <path fill="currentColor" d="m4.23 3.16l-3 4.39h18.6l-3.1-4.22z" opacity=".2" />
    <rect
      width="12.66"
      height="20.39"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      rx="3"
      transform="matrix(0 -1 -1 0 22.29 20.21)" />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M1.9 12.07v-2.5c0-2.83 0-4.24.88-5.12s2.3-.88 5.12-.88h6.16c1.74 0 2.61 0 3.32.43c.71.42 1.13 1.19 1.96 2.72l.17.33" />
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M18.44 13.88a.7.7 0 1 1-1.4 0a.7.7 0 0 1 1.4 0" />
  </g>
</svg>
